import styled from "styled-components";

export const WrapperResult = styled.div`
  display: flex;
  margin: 20px;
  padding: 30px;
  flex-direction: column;
  strong {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

export const ButtonResult = styled.button`
  display: flex;
  width: 100%;
`;

export const cellWrapText = {
  whiteSpace: 'normal !important',
};
